import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import qs from 'qs';

export default function useQueryParamState(key, defaultValue) {
  const history = useNavigate();
  const { search } = useLocation();
   
  const sampleObj = {};
  sampleObj[key] = defaultValue;
  const foundVal = { ...sampleObj, ...qs.parse(search, { ignoreQueryPrefix: true }) }[key];
  const initialVal =
    typeof foundVal === 'undefined' && typeof defaultValue !== 'undefined'
      ? defaultValue
      : foundVal;
  const [value, setValue] = useState(initialVal);

  const mergeSearch = useCallback(
    function mergeSearch(obj) {
      return qs.stringify({ ...qs.parse(search, { ignoreQueryPrefix: true }), ...obj });
    },
    [search]
  );

  // Update state when history changes
  useEffect(() => {
    setValue(foundVal);
  }, [foundVal]);

  // Update history when state changes
  useEffect(() => {
    if (value !== foundVal) {
      sampleObj[key] = value;
      history({
        search: mergeSearch(sampleObj),
      });
    }
     
  }, [value]);
  return [value, setValue, mergeSearch];
}
